var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkUnchecked = function SvgCheckmarkUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h142.545v32H0V0z"
  })));
};
export default SvgCheckmarkUnchecked;